import {Distance} from '../../Domain/Distance';
import {Duration} from '../../Domain/Duration';
import {formatDistance} from '../../Ui/Support/Formatting/formatDistance';
import {formatTime} from '../../Ui/Support/Formatting/formatTime';

export enum XAxisUnit {
    Strokes,
    Distance,
    Time,
}
export const getXAxisUnitFromKey = (key: string): XAxisUnit => {
    if (!isNaN(parseInt(key, 0))) {
        key = XAxisUnit[parseInt(key, 0)];
    }
    if (key === 'Strokes') {
        return XAxisUnit.Strokes;
    }
    if (key === 'Distance') {
        return XAxisUnit.Distance;
    }
    if (key === 'Time') {
        return XAxisUnit.Time;
    }
    throw new Error(`Could not get XAxisUnit from key ${key}.`);
};
export const getXAxisUnitLabel = (x: XAxisUnit): string => {
    if (x === XAxisUnit.Strokes) {
        return 'Stroke number';
    }
    if (x === XAxisUnit.Distance) {
        return 'Distance';
    }
    if (x === XAxisUnit.Time) {
        return 'Elapsed time';
    }
    throw new Error(`Could not get label for XAxisUnit ${x}.`);
};
export const getXAxisUnitInnerProperty = (x: XAxisUnit): string => {
    if (x === XAxisUnit.Strokes) {
        return 'strokeNumber';
    }
    if (x === XAxisUnit.Distance) {
        return 'fullWorkoutTotalDistance.millimeters';
    }
    if (x === XAxisUnit.Time) {
        return 'totalTime.milliseconds';
    }
    throw new Error(`Could not get inner property for XAxisUnit ${x}.`);
};
export const getXAxisUnitFormatter = (x: XAxisUnit): ((n: number) => string) => {
    if (x === XAxisUnit.Strokes) {
        return (value: number) => Math.floor(value).toString();
    }
    if (x === XAxisUnit.Distance) {
        return (value: number) => [formatDistance(Distance.fromMillimeters(value))].map((f) => f.formatted + f.unit)[0];
    }
    if (x === XAxisUnit.Time) {
        return (value: number) => formatTime(Duration.fromMilliseconds(value)).formatted;
    }
    throw new Error(`Could not get unit formatter for XAxisUnit ${x}.`);
};
